import type { BeckyModel } from '@wix/thunderbolt-becky-root'
import type { Data } from '@wix/thunderbolt-becky-types'
import { CatharsisSymbol, singleTransaction } from '@wix/thunderbolt-catharsis'
import { multi, withDependencies } from '@wix/thunderbolt-ioc'
import { CompNodeProviderSymbol } from './symbols'
import type { SingleTransaction } from './types'

export const singleTransactionCatharsisFactory = withDependencies(
	[CatharsisSymbol, multi(CompNodeProviderSymbol)] as const,
	(catharsis, features): SingleTransaction => {
		const usedDataMaps = new Set<keyof Data>(features.flatMap((feature) => feature.getUsedDataMaps()))
		return {
			execute: (beckyModel: BeckyModel, runAndReport: <T>(fn: () => T, name: string) => T) => {
				singleTransaction(catharsis, beckyModel, usedDataMaps, runAndReport)
			},
		}
	}
)
